"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _AaRecentSearchesRepository = require("./AaRecentSearchesRepository.model");

var _AaStorageClient = _interopRequireDefault(require("../AaStorageClient"));

var RECENT_SEARCHES_KEY = 'hotelRecentSearches';
var MAX_STORED_ITEMS = 10;
var recentSearches = [];

_AaStorageClient["default"].getItem(RECENT_SEARCHES_KEY).then(function (retrievedRecentSearches) {
  if (!retrievedRecentSearches) return;
  var decodedSearches = decodeURIComponent(retrievedRecentSearches);
  recentSearches = JSON.parse(decodedSearches).slice(0, MAX_STORED_ITEMS);
});

var syncToStorage = function syncToStorage() {
  var stringifiedSearches = JSON.stringify(recentSearches);
  var encodedSearches = encodeURIComponent(stringifiedSearches);

  _AaStorageClient["default"].setItem(RECENT_SEARCHES_KEY, encodedSearches);
};

var removeSearchesByDestinationId = function removeSearchesByDestinationId(id) {
  recentSearches = recentSearches.filter(function (recentSearch) {
    return recentSearch.destination.id !== id;
  });
};

var addRecentSearch = function addRecentSearch(recentSearch) {
  removeSearchesByDestinationId(recentSearch.destination.id);
  recentSearches.unshift(recentSearch);

  if (recentSearches.length > MAX_STORED_ITEMS) {
    recentSearches.pop();
  }

  syncToStorage();
};

var getRecentSearches = function getRecentSearches() {
  return (0, _toConsumableArray2["default"])(recentSearches);
};

var _default = {
  getRecentSearches: getRecentSearches,
  addRecentSearch: addRecentSearch
};
exports["default"] = _default;